import { appConfigStore } from 'Models/AppConfigStore';
import { getLowerCaseMessageByKey } from 'Stores/LanguageStore';
import { upperCaseFirst } from 'Util/StringUtils';

export const vehicleTrailerTitle = () => {
	let title = `${upperCaseFirst(getLowerCaseMessageByKey('vehicle__name__label', 'Vehicle'))}`;
	if (appConfigStore.trailersEnabled && !appConfigStore.trailerHasOwnPricing) {
		title += ' / Trailer';
	}
	return title;
};
